import {
  Brand,
  Company,
  CompanyInfo,
  Content,
  Details,
  Info,
  Iso,
  Line,
  Logo,
  Rights,
  Row,
  Title,
  Wrapper,
} from './Footer.styles';

interface FooterProps {
  noExtraSpace?: boolean;
}

const Footer = ({ noExtraSpace = false }: FooterProps): JSX.Element => {
  return (
    <Wrapper noExtraSpace={noExtraSpace}>
      <Content>
        <Row>
          <Company>
            <Brand>
              <Logo src="/Bid2board.png" alt="bid2board" />
            </Brand>
            <CompanyInfo>Digitalizing Marine Technical Service</CompanyInfo>
          </Company>
          <Info>
            <Title>Company</Title>
            <Details href="/about-us">About us</Details>
            <Details href="https://medium.com/bid2board">Blog</Details>
            <Details href="/media-page">Media page</Details>
            <Iso src="/iso-logo.jpg" alt="ISO 27001" />
          </Info>
          <Info>
            <Title>Legal</Title>
            <Details href="/privacy-policy">Privacy policy / GDPR</Details>
            <Details href="/terms-and-conditions">
              Terms &amp; Conditions
            </Details>
            <Details
              href="/quality_information_security_policy.pdf"
              target="_blank"
              title="Quality &amp; Information security policy PDF"
            >
              Quality &amp; Information security policy
            </Details>
          </Info>
          <Info>
            <Title>Contact</Title>
            <Details href="https://www.google.gr/maps/place/%CE%9B%CE%B5%CF%89%CF%86.+%CE%91%CF%86%CE%B5%CE%BD%CF%84%CE%BF%CF%8D%CE%BB%CE%B7+2,+%CE%A0%CE%B5%CE%B9%CF%81%CE%B1%CE%B9%CE%AC%CF%82+185+37/@37.9363073,23.6414381,21z/data=!4m5!3m4!1s0x14a1bbde7ccec197:0x9a3ab40e2a17f10d!8m2!3d37.9364156!4d23.6415448">
              Afentouli 2, 18536, Piraeus, Greece
            </Details>
            <Details href="tel:+302106773242">+30 210 6773242</Details>
            <Details href="/contact">Email us</Details>
            <Details href="/support">Support</Details>
          </Info>
        </Row>
        <Line />
        <Rights>
          <span>
            Copyright © bid2board ™&nbsp;
            {new Date().getFullYear()}
          </span>
          <span>All rights reserved</span>
        </Rights>
      </Content>
    </Wrapper>
  );
};

export default Footer;
